import { render, staticRenderFns } from "./ClubhouseinJapan.vue?vue&type=template&id=99f57b06"
import script from "./ClubhouseinJapan.vue?vue&type=script&lang=js"
export * from "./ClubhouseinJapan.vue?vue&type=script&lang=js"
import style0 from "./ClubhouseinJapan.vue?vue&type=style&index=0&id=99f57b06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports